import { lazy } from "react";
import { Navigate } from "react-router-dom";

const HomeLayout = lazy(() => import("../layouts/HomeLayout.jsx"));
const DesignLayout = lazy(() => import("../layouts/DesignLayout.jsx"));

const HomeView = lazy(() => import("../views/home/HomeView.jsx"));
const DesignHomeView = lazy(() => import("../views/design/DesignHomeView.jsx"));
const PreviewHomeView = lazy(() => import("../views/design/preview/PreviewHomeView.jsx"));

/** Research & Development */
const ResearchDevelopmentView = lazy(() => import("../R&D/ResearchDevelopmentView.jsx"));
const UpdateNestedElementView = lazy(() => import("../R&D/UpdateNestedElementView.jsx"));
const DragUpDownListView = lazy(() => import("../R&D/DragUpDownListView.jsx"));
const RecordVoiceView = lazy(() => import("../R&D/RecordVoiceView.jsx"));
const ColorPickerView = lazy(() => import("../R&D/ColorPickerView.jsx"));

const ThemeRoutes = [
    {
        path: "/",
        element: <HomeLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
        ]
    },

    {
        path: "/design",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <DesignHomeView /> },
            { path: "preview/*", exact: true, element: <PreviewHomeView /> },
        ]
    },

    {
        path: "/rd",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <ResearchDevelopmentView /> },
            { path: "TOVFORM-12", exact: true, element: <UpdateNestedElementView />},    
            { path: "TOVFORM-37", exact: true, element: <DragUpDownListView />},
            { path: "TOVFORM-5", exact: true, element: <RecordVoiceView />},
            { path: "color", exact: true, element: <ColorPickerView /> }
        ]
    }
        
]
export default ThemeRoutes;